import type { i18n as I18nType } from 'i18next'

import { AUTH_TRANSLATION_NAMESPACE } from './translation'

export const messages = {
  continue: 'Continue',
  logout: 'Logout',
  inactivityWarning:
    'In 1 minute you are about to be logged out due to inactivity.',
  sessionInactivity: 'Session inactivity',
  externalRoute: {
    expiredToken: {
      title: 'There was a problem with your access',
      description: 'Your link has expired. Please contact your administrator.',
    },
  },
  inactivity: {
    default: {
      title: 'Login Required',
      text: 'Due to inactivity and security reasons, you have been logged out. To continue please log in.',
      buttonLabel: 'Return to Log On',
    },
    external: {
      title: 'Session Expired',
      text: 'Due to inactivity and security reasons, your access has been revoked. To refresh your access please use the button below.',
      buttonLabel: 'Refresh access',
    },
  },
}

export const setupTranslations = (instance: I18nType) => {
  instance.addResourceBundle(
    'en',
    AUTH_TRANSLATION_NAMESPACE,
    messages,
    true,
    true,
  )
}
